export function WelcomeStepTitle({
  eyebrow,
  title,
  sub,
}: {
  eyebrow: string;
  title: string;
  sub?: string;
}) {
  return (
    <div className="mb-6">
      <p className="mb-2.5 text-sm font-semibold">
        {eyebrow}
      </p>
      <h1 className="mb-2 text-[30px] leading-[1.15] font-semibold text-foreground">
        {title}
      </h1>
      {sub ? (
        <p className="max-w-[540px] text-sm leading-relaxed text-muted-foreground">{sub}</p>
      ) : null}
    </div>
  );
}
